import { Skeleton } from '@worldcoo/ui/components/skeleton';

/**
 * Route-owned pending UI for the donate flow, following the route-owns-its-skeleton pattern:
 * each step route sets this as its `pendingComponent`, so a step that suspends on its data or
 * its chunk swaps in a card-shaped skeleton in place of the step content. Without it the step
 * falls through to the router-wide `defaultPendingComponent` (which renders nothing) and the
 * card the donate layout keeps mounted collapses to empty mid-flow.
 *
 * One shared skeleton for all steps on purpose: the layout already keeps the card, the progress
 * bar and the chrome in place, and every step is the same shape at this fidelity (heading,
 * a couple of text lines, a block of controls, a primary action).
 */
export function DonateStepPending() {
	return (
		<div className="flex h-full grow flex-col gap-6">
			<div className="flex flex-col items-center gap-3">
				<Skeleton className="h-8 w-56" />
				<Skeleton className="h-4 w-full" />
				<Skeleton className="h-4 w-4/5" />
			</div>
			<div className="grid grid-cols-2 gap-2">
				<Skeleton className="h-14 rounded-[12px]" />
				<Skeleton className="h-14 rounded-[12px]" />
				<Skeleton className="h-14 rounded-[12px]" />
				<Skeleton className="h-14 rounded-[12px]" />
			</div>
			<Skeleton className="h-14 w-full rounded-[12px]" />
			<Skeleton className="h-14 w-full rounded-[12px]" />
		</div>
	);
}
